/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {ThemeColorPath, ThemeColorTextPath} from 'platform/foundation';

export const BRANCH_BADGE_COLORS: readonly ThemeColorPath[] = [
  'palettes.blue.60.100',
  'palettes.teal.60.100',
  'palettes.purple.60.100',
  'palettes.magenta.60.100',
  'palettes.orange.60.100',
  'palettes.green.60.100',
  'palettes.red.60.100',
  'palettes.yellow.60.100',
];

export const BRANCH_BADGE_FALLBACK_COLOR: ThemeColorPath = 'palettes.blue.60.100';

export const BRANCH_BADGE_TEXT_COLOR: ThemeColorTextPath = 'white';

export const BRANCH_BADGE_SIZE = 7;
